import {Component, forwardRef, Input, OnDestroy, ViewEncapsulation} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subject} from 'rxjs';
import {IoniconsOutline} from "@pt/pt-models";
import {ListCapabilityResponse} from "it/primatoo/openapi/api/org/schemas/capability/ListCapabilityResponse";

@Component({
  selector: 'pt-input-user-permission-select',
  templateUrl: './input-user-permission-select.component.html',
  styles: [`
    .permission-help {
      opacity: .7;
      /*width: 20px;*/
      /*display: inline-flex;*/
    }

    .permission-help:hover {
      cursor: pointer;
      opacity: 1;
    }

    .input-help-popover .popover-body {
      background-color: rgb(210, 210, 210);
      color: var(--bs-dark);
      padding: 2px 5px;
    }

    .input-help-popover .popover-arrow::after, .popover .popover-arrow::before {
      background-color: transparent !important;
      border-right-color: rgb(210, 210, 210) !important;
    }

    .form-check-input {
      margin-top: 4px;
    }

  `],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputUserPermissionSelectComponent)
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputUserPermissionSelectComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class InputUserPermissionSelectComponent implements OnDestroy, ControlValueAccessor {
  @Input() controlName: string;
  @Input() options: ListCapabilityResponse; //FindAllCapabilityResponse;
  public isDisabled = false;
  public selectedPermission: string[] = [];
  public iconInfo = IoniconsOutline.infoCircle;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val) => void;
  private onTouched: () => void;

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  writeValue(permissionKey: string[]): void {
    this.selectedPermission = permissionKey || [];
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  validate(value: FormControl) {
    return true;
  }

  togglePerm(perm: any /* CapabilityInfo*/) {
    if (!this.selectedPermission) {
      this.selectedPermission = [];
    }
    if (this.selectedPermission.includes(perm.key)) {
      this.selectedPermission = this.selectedPermission.filter((p) => p !== perm.key);
    } else {
      this.selectedPermission.push(perm.key);
    }
    this.onChanged(this.selectedPermission);
    this.onTouched();
  }

  toggleWithGreeting(popover, description?: string) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open({description});
    }
  }
}
